import React from "react";
import { Routes } from "react-router-dom";

import { HackerDirectoryRoute } from "src/shared/constants/route";
import { Permission } from "src/shared/contexts";
import NotFound from "src/views/404";

import { Route } from "../../shared/components";

import HackerDirectoryDirectory from "./directory";
import HackerDirectoryGate from "./gate";
import HackerDirectoryHome from "./home";
import HackerDirectoryProfile from "./profile";
import HackerDirectoryYourProfile from "./your-profile";

export const HackerDirectoryRoutes = () => (
  <Routes>
    <Route
      path={HackerDirectoryRoute.HOME}
      element={<HackerDirectoryHome />}
      requirePermissions={[
        Permission.HACKER_EVENT_ACCESS,
        Permission.ORGANIZER,
      ]}
      requireAll={false}
    />
    <Route
      path={HackerDirectoryRoute.DIRECTORY}
      element={
        <HackerDirectoryGate>
          <HackerDirectoryDirectory />
        </HackerDirectoryGate>
      }
      requirePermissions={[
        Permission.HACKER_EVENT_ACCESS,
        Permission.ORGANIZER,
      ]}
      requireAll={false}
    />
    <Route
      path={HackerDirectoryRoute.PROFILE}
      element={
        <HackerDirectoryGate>
          <HackerDirectoryProfile />
        </HackerDirectoryGate>
      }
      requirePermissions={[
        Permission.HACKER_EVENT_ACCESS,
        Permission.ORGANIZER,
      ]}
      requireAll={false}
    />
    <Route
      path={HackerDirectoryRoute.YOUR_PROFILE}
      element={<HackerDirectoryYourProfile />}
      requirePermissions={[
        Permission.HACKER_EVENT_ACCESS,
        Permission.ORGANIZER,
      ]}
      requireAll={false}
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);
